<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <card>
        <div class="d-none d-md-block">
          <el-table
            class="table-striped"
            :header-cell-style="headerCellStyle"
            header-row-class-name="text-danger"
            highlight-current-row
            @current-change="handleCurrentChange"
            :cell-style="cellStyle"
            :data="summaryRowData"
          >
            <el-table-column
              label="Meeting"
              prop="AgendaName"
              :width="agendaNameWidth"
            />
            <el-table-column
              label="Start"
              prop="StartDate"
              :formatter="dateFormatter"
              width="130px"
            />
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="End"
              prop="EndDate"
              :formatter="timeFormatter"
              width="70px"
            />
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="Location"
              prop="Location"
              width="200px"
            />
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="Notes"
              prop="Description"
            />
          </el-table>
        </div>
        <div class="d-block d-md-none">
          <el-table
            class="table-striped"
            :header-cell-style="headerCellStyle"
            header-row-class-name="text-danger"
            highlight-current-row
            @current-change="handleCurrentChange"
            :cell-style="cellStyle"
            :data="summaryRowData"
          >
            <el-table-column
              label="Meeting"
              prop="AgendaName"
            />
            <el-table-column
              label="Start"
              prop="StartDate"
              :formatter="dateFormatter"
            />
          </el-table>
        </div>
        <p-button
          v-if="agendaTypeId === COURSE_DAY"
          type="primary"
          :disabled="disableButtons"
          @click="print('schedule')"
        >
          Print Full Schedule
        </p-button>
        <p-button
          v-if="agendaTypeId === COURSE_DAY"
          type="primary"
          :disabled="disableButtons"
          @click="print('cards')"
        >
          Print Schedule Pocket Cards
        </p-button>
      </card>
      <card v-if="agenda">
        <div class="text-right">
          <p-button
            v-if="agendaTypeId === COURSE_DAY"
            type="primary"
            :disabled="disableSingleDayPrintButton"
            @click="print('singleday')"
          >
            Print
          </p-button>
          <p-button
            v-if="agendaTypeId === STAFF_DEVELOPMENT"
            type="primary"
            :disabled="disableButtons"
            @click="print('staffdev')"
          >
            Print
          </p-button>
        </div>
        <div class="d-none d-md-block">
          <el-table
            class="table-striped"
            :header-cell-style="headerCellStyle"
            header-row-class-name="text-danger"
            :cell-style="cellStyle"
            :data="agenda.AgendaItems"
          >
            <el-table-column
              label="Start"
              prop="StartTime"
              :formatter="timeFormatter"
              width="70px"
            />
            <el-table-column
              v-if="agendaTypeId === STAFF_DEVELOPMENT"
              label="Duration"
              prop="DurationMinutes"
              class-name="d-none d-md-table-cell text-center"
              width="100px"
            />
            <el-table-column
              label="Title"
              prop="Topic"
            />
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="Presented By"
              width="100px"
            >
              <template slot-scope="props">
                {{ getStaffName(props.row.PresenterScouterKey) }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="agendaTypeId === STAFF_DEVELOPMENT"
              class-name="d-none d-md-table-cell"
              label="Notes"
              prop="Notes"
            />
            <el-table-column
              v-if="agendaTypeId === COURSE_DAY"
              class-name="d-none d-md-table-cell"
              label="Location"
              width="120px"
              prop="LocationInfo"
            />
            <el-table-column
              v-if="agendaTypeId === COURSE_DAY"
              class-name="d-none d-md-table-cell"
              label="Quartermaster"
            >
              <template slot-scope="props">
                <div v-html="props.row.QuartermasterInfo" />
              </template>
            </el-table-column>
            <el-table-column
              v-if="agendaTypeId === COURSE_DAY"
              label="Page"
              width="50px"
              class-name="d-none d-md-table-cell text-center"
              prop="CurriculumReference"
            />
            <el-table-column
              v-if="agendaTypeId === COURSE_DAY"
              label="Audience"
              width="70px"
              class-name="d-none d-md-table-cell text-center"
              prop="Audience"
            />
            <el-table-column
              v-if="agendaTypeId === COURSE_DAY"
              class-name="d-none d-md-table-cell"
              label="Notebook"
              prop="NotebookPages"
            />
          </el-table>
        </div>
        <div class="d-block d-md-none">
          <el-table
            class="table-striped"
            :header-cell-style="headerCellStyle"
            header-row-class-name="text-danger"
            :cell-style="cellStyle"
            :data="agenda.AgendaItems"
          >
            <el-table-column
              label="Start"
              prop="StartTime"
              :formatter="timeFormatter"
              width="70px"
            />
            <el-table-column
              label="Title"
              prop="Topic"
            />
          </el-table>
        </div>
        <print-course-schedule-single-day
          v-if="agendaTypeId === COURSE_DAY"
          v-show="showPrint"
          :agenda="agenda"
          :staff="staff"
        />
        <print-staff-development
          v-if="agendaTypeId === STAFF_DEVELOPMENT"
          :agenda="agenda"
          v-show="showPrint"
          :staff="staff"
        />
      </card>
    </div>
    <print-course-schedule
      v-if="agendaTypeId === COURSE_DAY && staff && summaryRowData"
      v-show="showPrint"
      :agendas="summaryRowData"
      :staff="staff"
    />
    <print-course-schedule-cards
      v-if="agendaTypeId === COURSE_DAY && staff && summaryRowData"
      v-show="showPrint"
      :agendas="summaryRowData"
      :staff="staff"
    />
  </div>
</template>

<script>
import agendaApi from '@/services/api/agenda'
import scouterApi from '@/services/api/scouter'
import formatter from '@/services/formatter.js'
import oops from '@/components/_main/oops.vue'
import printStaffDevelopment from '@/components/agendas/print-views/print-staff-development.vue'
import printCourseScheduleSingleDay from '@/components/agendas/print-views/print-course-schedule-single-day.vue'
import printCourseSchedule from '@/components/agendas/print-views/print-course-schedule.vue'
import printCourseScheduleCards from '@/components/agendas/print-views/print-course-schedule-cards.vue'

export default {
  name: 'Agenda',
  props: {
    agendaTypeId: {
      type: Number,
      default: null
    }
  },
  components: {
    oops,
    printStaffDevelopment,
    printCourseScheduleSingleDay,
    printCourseSchedule,
    printCourseScheduleCards
  },
  data: function () {
    return {
      cellStyleStaffDev: { padding: '0', height: '20px', 'font-size': '10px', cursor: 'pointer' },
      headerCellStyleStaffDev: { padding: '0', height: '20px', 'font-size': '10px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      cellStyleCourse: { padding: '0', height: '20px', 'font-size': '9px', cursor: 'pointer' },
      headerCellStyleCourse: { padding: '0', height: '20px', 'font-size': '9px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      summaryRowData: null,
      loading: true,
      errormessage: null,
      staff: {},
      agenda: null,
      showPrint: false,
      printItem: '',
      printOptions: null,
      disableButtons: false
    }
  },
  watch: {
    printItem: function (oldValue, newValue) {
      this.$nextTick(function () {
        if (this.printItem !== '') {
          this.$htmlToPaper(this.printItem, this.printOptions)
        }
        this.printItem = ''
      })
    }
  },
  computed: {
    agendaNameWidth: function () {
      if (this.agendaTypeId === this.STAFF_DEVELOPMENT) {
        return '225px'
      } else if (this.agendaTypeId === this.COURSE_DAY) {
        return '100px'
      } else {
        return ''
      }
    },
    headerCellStyle: function () {
      if (this.agendaTypeId === this.STAFF_DEVELOPMENT) {
        return this.headerCellStyleStaffDev
      } else if (this.agendaTypeId === this.COURSE_DAY) {
        return this.headerCellStyleCourse
      } else {
        return ''
      }
    },
    cellStyle: function () {
      if (this.agendaTypeId === this.STAFF_DEVELOPMENT) {
        return this.cellStyleStaffDev
      } else if (this.agendaTypeId === this.COURSE_DAY) {
        return this.cellStyleCourse
      } else {
        return ''
      }
    },
    disableSingleDayPrintButton: function () {
      return this.disableButtons || !(this.agenda)
    }
  },
  created () {
    this.STAFF_DEVELOPMENT = 1
    this.COURSE_DAY = 2
    this.OTHER = 3
  },
  mounted () {
    this.getStaffList()
    if (this.agendaTypeId === this.STAFF_DEVELOPMENT) {
      agendaApi.listStaffDevelopmentAgendas(this.$root.courseKey)
        .then(x => {
          this.summaryRowData = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    } else if (this.agendaTypeId === this.COURSE_DAY) {
      agendaApi.listCourseDayAgendas(this.$root.courseKey)
        .then(x => {
          this.summaryRowData = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  methods: {
    getStaffName: function (scouterKey) {
      const scouter = this.staff[scouterKey]

      if (scouter === undefined) {
        return ''
      } else {
        return scouter
      }
    },
    getStaffList: function () {
      scouterApi.getStaffLookups(this.$root.courseKey, true)
        .then(y => {
          this.staff = y
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPresenterName: function (pKey) {
      let returnValue = ''
      for (let i = 0; i < this.staff.length; i++) {
        if (this.staff[i].ScouterKey === pKey) {
          returnValue = this.staff[i].FullName
          break
        }
      }
      return returnValue
    },
    handleCurrentChange: function (row) {
      this.agenda = row
    },
    print: function (printSection) {
      if (printSection === 'cards') {
        this.printOptions = {
          styles: [
            '/kidlat.css',
            '/bootstrap.min.css',
            '/chalk-theme.css',
            '/printer-styles/two-beads-print.css',
            '/printer-styles/agenda-pocket-cards.css'
          ]
        }
      } else if (printSection === 'staffdev') {
        this.printOptions = {
          styles: [
            '/kidlat.css',
            '/bootstrap.min.css',
            '/chalk-theme.css',
            '/printer-styles/two-beads-print.css',
            '/printer-styles/header-footer.css',
            '/printer-styles/agenda-staff-dev.css'
          ]
        }
      } else {
        this.printOptions = {
          styles: [
            '/kidlat.css',
            '/bootstrap.min.css',
            '/chalk-theme.css',
            '/printer-styles/two-beads-print.css',
            '/printer-styles/two-beads-print-landscape.css',
            '/printer-styles/header-footer.css',
            '/printer-styles/agenda-course-day.css'
          ]
        }
      }
      // Should cause updated to fire
      this.printItem = printSection
    },
    timeFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsTime(cellValue)
    },
    dateFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsDateTime(cellValue)
    },
    shortDateFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsDate(cellValue)
    }
  }
}
</script>
